export default class PreConta {
    constructor(Empresa, Usuario, Certificado) {
        this.Empresa = Empresa;
        this.Usuario = Usuario;
        this.Certificado = Certificado;
    }
}


// WEBPACK FOOTER //
// ./src/domain/conta/PreConta.js